export class DownloadForm {
  constructor() {
    if (document.getElementById('download-form') === null) return

    const checkList = document.querySelectorAll('input[name="your_download[data][]"]')
    const node = Array.prototype.slice.call(checkList, 0)
    node.forEach(function (elm) {
      let id = elm.value
      let thumbnail = '<div class="thumbnail"><img src="' + downloadList[id] + '"></div>'
      let parent = elm.parentNode
      parent.insertAdjacentHTML('beforeend', thumbnail)
    })
  }
}
